export default __webpack_public_path__ + "static/Humanity-e51353438b224060402a25a1fa490cfa.png";